var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[(_vm.pcShow)?_c('pc-home',{staticClass:"pc-div"}):_vm._e(),(_vm.mobileShow)?_c('mobile-home',{staticClass:"mobile-div"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }